import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";

const roleApi = {
  getAll: () => {
    const url = "roles/getAllRoles";
    return axiosClient.get(url);
  },
  getRolesPaging: (params) => {
    const url = "roles";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },
  createRole: (params) => {
    const url = "roles";
    return axiosClient.post(url, params);
  },
  updateRole: (id, payload) => {
    const url = "roles/";

    return axiosClient.patch(url + id, payload);
  },

  deleteRole: (id) => {
    const url = "roles/";
    return axiosClient.delete(url + id);
  },
  deleteRoles: (params) => {
    const url = "roles";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },

};

export default roleApi;
